/* global $ */

import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['element', 'template'];

  newContent() {
    return this.templateTarget.content.children[0].cloneNode(true);
  }

  connect() {
    $(this.elementTarget).popover({
      html: true,
      container: 'body',
      placement: 'bottom',
      content: () => this.newContent(),
    });
  }
}
